import * as React from "react";
const SvgFiRrMarketplaceStore = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-marketplace-store_svg__a)">
      <path
        fill="#062147"
        d="M22 18.184v-6.741c1.19-.694 2-1.97 2-3.444a1 1 0 0 0-.038-.275L22.79 3.625a5.02 5.02 0 0 0-4.808-3.626H6.018a5.03 5.03 0 0 0-4.809 3.627L.038 7.725A1 1 0 0 0 0 8c0 1.474.81 2.75 2 3.444v6.741a3 3 0 0 0-2 2.816c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3a3 3 0 0 0-2-2.817M3.132 4.176A3.02 3.02 0 0 1 6.018 2H7v2a1 1 0 1 0 2 0V2h6v2a1 1 0 1 0 2 0V2h.982c1.332 0 2.519.895 2.885 2.176l1.129 3.951A2.003 2.003 0 0 1 20 10.001h-1c-1.103 0-2-.897-2-2a1 1 0 1 0-2 0c0 1.103-.897 2-2 2h-2c-1.103 0-2-.897-2-2a1 1 0 1 0-2 0c0 1.103-.897 2-2 2H4a2 2 0 0 1-1.996-1.874zM5 12a3.97 3.97 0 0 0 3-1.382A3.97 3.97 0 0 0 11 12h2a3.97 3.97 0 0 0 3-1.382A3.97 3.97 0 0 0 19 12h1v6h-4.5a1 1 0 0 0-.707.293l-.707.707H9.914l-.707-.707A1 1 0 0 0 8.5 18H4v-6zm16 10H3a1.001 1.001 0 0 1 0-2h5.086l.707.707A1 1 0 0 0 9.5 21h5c.266 0 .52-.105.707-.293l.707-.707H21a1.001 1.001 0 0 1 0 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-marketplace-store_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMarketplaceStore;
